import { KnBrQuoteEntryService } from 'src/app/store/kn-br-quote-entry/kn-br-quote-entry.service';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { KnBrDraftOrdersService } from 'src/app/store/kn-br-draft-orders/kn-br-draft-orders.service';
import { KnBrQuoteContextService } from 'src/app/store/kn-br-quote-context/kn-br-quote-context.service';
import { KnBrCartContextService } from 'src/app/store/kn-br-cart-context/kn-br-cart-context.service';
import { KnBrOrderHistoryService } from '../../store/kn-br-order-history/kn-br-order-history.service';
import { UntypedFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, ChangeDetectorRef, OnDestroy, ViewContainerRef } from '@angular/core';
import { KnBrAddProductsComponent } from 'src/app/kn-br-customer360/kn-br-order-detail/kn-br-add-products/kn-br-add-products.component';
import { createFrom, EventService, TranslatePipe } from '@spartacus/core';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { KnBrQuotesService } from 'src/app/store/kn-br-quotes/kn-br-quotes.service';
import { map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { LaunchDialogService, MediaComponent } from '@spartacus/storefront';
import { Actions, ofType } from '@ngrx/effects';
import { KnBrOrderHistoryActionTypes } from 'src/app/store/kn-br-order-history/kn-br-order-history.action';
import { QuickorderSearchSuccess } from 'src/app/store/custome-spartacus-events';
import { KnBrAddToCartComponent } from '../../kn-br-product/kn-br-add-to-cart/kn-br-add-to-cart.component';
import { KnBrAddToQuoteComponent } from '../../kn-br-product/kn-br-add-to-quote/kn-br-add-to-quote.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { KnBrNumbersOnlyDirective } from '../../shared/directive/kn-br-numbers-only.directive';

@Component({
    selector: 'knbr-kn-br-quick-order',
    templateUrl: './kn-br-quick-order.component.html',
    styleUrls: ['./kn-br-quick-order.component.scss'],
    imports: [KnBrAddToCartComponent, KnBrAddToQuoteComponent, ReactiveFormsModule, NgClass, MediaComponent, KnBrNumbersOnlyDirective, AsyncPipe, TranslatePipe]
})
export class KnBrQuickOrderComponent extends KnBrAddProductsComponent implements OnInit, OnDestroy {
  cartContext;
  quoteContext;
  selectedProductCodes;
  customerContext: string;

  quoteItems$: Observable<number> = this.knBrQuoteService.get$.pipe(
    startWith({ totalItems: 0 }),
    map((quote) => (quote && quote.totalItems) || 0)
  );
  cartItems$: Observable<number> = this.activeCartService.getActive().pipe(
    startWith({ totalItems: 0 }),
    map((cart) => (cart && cart.totalItems) || 0)
  );
  constructor(
    protected formBuilder: UntypedFormBuilder,
    protected cdr: ChangeDetectorRef,
    protected knBrOrderHistoryService: KnBrOrderHistoryService,
    protected knBrCartContextService: KnBrCartContextService,
    protected knBrQuoteContextService: KnBrQuoteContextService,
    protected knBrDraftOrderService: KnBrDraftOrdersService,
    protected knbrCommonService: KnBrCommonService,
    protected activeCartService: ActiveCartService,
    protected knBrQuoteService: KnBrQuotesService,
    protected knBrCustomerContextService: KnBrCustomerContextService,
    protected launchDialogService: LaunchDialogService,
    protected vcr: ViewContainerRef,
    protected knBrQuoteEntryService: KnBrQuoteEntryService,
    private actions$: Actions,
    private eventService: EventService
  ) {
    super(
      formBuilder,
      cdr,
      knBrOrderHistoryService,
      knBrDraftOrderService,
      knbrCommonService,
      launchDialogService,
      vcr,
      knBrQuoteEntryService
    );
    this.subscription.add(
      this.knBrCartContextService.get$.subscribe((data) => {
        this.cartContext = data;
        this.cdr.markForCheck();
      })
    );
    this.subscription.add(
      this.knBrQuoteContextService.get$.subscribe((data) => {
        this.quoteContext = data;
        this.cdr.markForCheck();
      })
    );
    this.subscription.add(
      this.knBrCustomerContextService.getActiveCustomerNumber().subscribe((response) => {
        this.customerContext = response ? response : null;
      })
    );
    this.actions$.pipe(ofType(KnBrOrderHistoryActionTypes.KnBrOrderFormsProductsSearchSuccessAction)).subscribe({
      next: (res: any) => {
        if (!res.payload.products[0].errorMsg) {
          this.eventService.dispatch(
            createFrom(QuickorderSearchSuccess, {
              event: 'ajaxComplete',
              attribute: 'productId',
              ProductId: res.payload.products[0].code,
            })
          );
        }
      },
    });
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  quickOrderChange(e) {
    const ga = (window as any).ga;
    const tracker = ga.getAll()[0];
    tracker.set('page', e.target.value);
    tracker.send('event');
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
